module.exports = __webpack_public_path__ + "img/payment-report.3e45f543.png";